export enum ZohoCandidateTypes {
  New = 1,
  ExistingNoCommunication = 2,
  ExistingWithCommunicationNotInProcess = 3,
  ExistingNoMatchesSpecialCase = 4,
  FoundMoreThanOneCandidate = 5,
  ExistingSignedToLpWithZohoId = 6,
  ExistingCurrentlyClosed = 7,
}
